import { Button, HStack, Text } from '@chakra-ui/react';
import { currentWallet } from '@cronos-app/wallet';
import { useAccountDialog } from '@ui/components/AccountDialog/useAccountDialog';
import { Address } from '@ui/components/Address';
import { useWalletModal } from '@ui/components/Wallet';
import { ChainIcons } from '@ui/config/layer';
import { useUserProfile } from '@ui/hooks/api/useUser';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';
import { useSwitchNetwork } from '@ui/hooks/useSwitchNetwork';

export const WalletNavItem = () => {
  const openWalletModal = useWalletModal((s) => s.openModal);
  const isConnected = currentWallet.useIsConnected();
  const chainLayer = useGlobalChainLayer();
  const isWrongNetwork = currentWallet.useIsWrongNetwork(chainLayer);
  const switchNetworkMutation = useSwitchNetwork();

  if (isWrongNetwork) {
    return (
      <Button
        size="sm"
        rounded="full"
        bgColor="background.offWhite"
        color="state.error"
        onClick={() => {
          switchNetworkMutation.mutateAsync();
        }}
      >
        Wrong network
      </Button>
    );
  }

  if (isConnected) {
    const ChainIcon = ChainIcons[chainLayer];
    return (
      <Button
        size="sm"
        rounded="full"
        bgColor="background.offWhite"
        color="text.default"
        onClick={() => {
          useAccountDialog.getState().open();
        }}
      >
        <HStack gap="8px">
          {ChainIcon && <ChainIcon boxSize="16px" />}
          <AddressOrName />
        </HStack>
      </Button>
    );
  }

  return (
    <Button minW="100px" size="sm" onClick={openWalletModal}>
      Connect
    </Button>
  );
};

const AddressOrName = () => {
  const account = currentWallet.useAccount();
  const { data: userProfile } = useUserProfile();
  return userProfile?.name ? (
    <Text
      whiteSpace="nowrap"
      textOverflow="ellipsis"
      overflow="hidden"
      maxW="12ch"
    >
      {userProfile.name}
    </Text>
  ) : (
    <Address address={account ?? ''} />
  );
};
